import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-column xl:flex-row xl:align-items-start p-5 mt-8" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "formgrid grid justify-content-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-12 sm:col-12 lg:col-5 xl:col-5 px-4 font-normal" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "registro_mensaje" }, "Crear cuenta"),
    /*#__PURE__*/_createElementVNode("div", { class: "pt-5 registro_font_s_20" }, " El registro es necesario para tener acceso a los productos y datos del Sistema de Información Energética ")
  ])
], -1)
const _hoisted_7 = { class: "md:col-12 sm:col-12 lg:col-5 xl:col-5 pt-5" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = { class: "field col-1 md:col-1 sm:col-1 xl:col-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "field col-11 md:col-11 sm:col-11 xl:col-11 p-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "" }, "Nuevo registro")
], -1)
const _hoisted_12 = { class: "p-fluid formgrid grid" }
const _hoisted_13 = { class: "field col-12 md:col-12 sm:col-12 xl:col-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "nombre" }, " Nombres *", -1)
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = { class: "field col-12 md:col-12 sm:col-12 xl:col-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "Apellido_pat" }, " Apellido Paterno *", -1)
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "field col-12 md:col-12 sm:col-12 xl:col-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "apellido_mat" }, " Apellido Materno *", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = { class: "field col-12 md:col-12 sm:col-12 xl:col-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Correo electrónico *", -1)
const _hoisted_24 = {
  key: 0,
  class: "p-error"
}
const _hoisted_25 = { class: "field col-12 md:col-12 lg:col-12 sm:col-12 xl:col-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "contrasenia" }, "Contraseña *", -1)
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h6", null, "Ingresa una contraseña", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Recomendaciones", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("ul", { class: "pl-2 ml-2 mt-0 registro_line_h" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Longitud mínima de 8 caracteres"),
  /*#__PURE__*/_createElementVNode("li", null, " Sólo se aceptan letras, números y los siguientes caracteres #$@.!%=¡&@#Ññ$¿+*?_/- "),
  /*#__PURE__*/_createElementVNode("li", null, " No se permiten secuencias por ejemplo: 123, abc "),
  /*#__PURE__*/_createElementVNode("li", null, " No debe contener el nombre de usuario en la contraseña "),
  /*#__PURE__*/_createElementVNode("li", null, "Debe contener al menos un número"),
  /*#__PURE__*/_createElementVNode("li", null, "Debe contener al menos una minúscula"),
  /*#__PURE__*/_createElementVNode("li", null, "Debe contener al menos una mayúscula"),
  /*#__PURE__*/_createElementVNode("li", null, "Debe contener un caracter no alfanumérico")
], -1)
const _hoisted_31 = {
  key: 0,
  class: "p-error"
}
const _hoisted_32 = { class: "field col-12 md:col-12 lg:col-12 sm:col-12 xl:col-12" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "contrasenia1" }, "Confirmar Contraseña *", -1)
const _hoisted_34 = { class: "field" }
const _hoisted_35 = {
  key: 0,
  class: "p-error"
}
const _hoisted_36 = { class: "field col-12 md:col-12 sm:col-12 xl:col-12" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "tel" }, " Número Telefónico (Favor de incluir la lada del país.) ", -1)
const _hoisted_38 = { class: "field col-12 md:col-12 lg:col-12 sm:col-12 xl:col-12" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "institucion" }, " Institución *", -1)
const _hoisted_40 = {
  key: 0,
  class: "p-error"
}
const _hoisted_41 = { class: "field col-12 md:col-12 lg:col-12 sm:col-12 xl:col-12" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "Sector *", -1)
const _hoisted_43 = {
  key: 0,
  class: "p-error"
}
const _hoisted_44 = { class: "field col-12 md:col-12 lg:col-12 sm:col-12 xl:col-12" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Nombre Sector (especificar)*", -1)
const _hoisted_46 = {
  key: 0,
  class: "p-error"
}
const _hoisted_47 = { class: "field col-12 md:col-12 lg:col-12 sm:col-12 xl:col-12" }
const _hoisted_48 = { class: "pt-2" }
const _hoisted_49 = { class: "field col-6 md:col-12 lg:col-6 sm:col-12 xl:col-6 p-2" }
const _hoisted_50 = { class: "field col-6 md:col-12 lg:col-6 sm:col-12 xl:col-6 p-2" }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { class: "formgrid grid justify-content-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-10 sm:col-12 lg:col-5 xl:col-5 px-4 font-normal" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "registro_mensaje" }, "Registro exitoso "),
    /*#__PURE__*/_createElementVNode("div", { class: "pt-5 registro_font_s_20" }, " El registro se ha generado ")
  ])
], -1)
const _hoisted_54 = { class: "md:col-10 sm:col-12 lg:col-5 xl:col-5 pt-5" }
const _hoisted_55 = { class: "card" }
const _hoisted_56 = { class: "formgrid grid" }
const _hoisted_57 = { class: "field col-12 md:col-12" }
const _hoisted_58 = { class: "flex-1 flex justify-content-center pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Message = _resolveComponent("Message")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_fa = _resolveComponent("fa")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CaptchaCanvas = _resolveComponent("CaptchaCanvas")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Toast),
      (_ctx.mostrar_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createBlock(_component_Message, {
              modelValue: _ctx.msg,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.msg) = $event)),
              severity: _ctx.msg.severity,
              key: _ctx.msg.content
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.msg.content), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "severity"]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.cargar)
        ? (_openBlock(), _createBlock(_component_spinner, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.registroNuevo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_fa, {
                        icon: "circle-user",
                        class: "registro_icon_usr"
                      })
                    ]),
                    _hoisted_11
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_InputText, {
                        id: "nombre",
                        modelValue: _ctx.state_reg_nuev.firstName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state_reg_nuev.firstName) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_ctx.vN$.firstName.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.vN$.firstName.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_InputText, {
                        id: "apPat",
                        modelValue: _ctx.state_reg_nuev.middleName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state_reg_nuev.middleName) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_ctx.vN$.middleName.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_ctx.vN$.middleName.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_InputText, {
                        id: "apMat",
                        modelValue: _ctx.state_reg_nuev.lastName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state_reg_nuev.lastName) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_ctx.vN$.lastName.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.vN$.lastName.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_InputText, {
                        id: "email",
                        modelValue: _ctx.state_reg_nuev.email,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state_reg_nuev.email) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_ctx.vN$.email.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(_ctx.vN$.email.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Password, {
                          id: "password",
                          modelValue: _ctx.vN$.password.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vN$.password.$model) = $event)),
                          modelModifiers: { trim: true },
                          class: _normalizeClass({
                                                    'p-invalid': _ctx.vN$.password.$error && _ctx.submit_reg_nuev,
                                                }),
                          toggleMask: ""
                        }, {
                          header: _withCtx(() => [
                            _hoisted_28
                          ]),
                          footer: _withCtx(() => [
                            _createVNode(_component_Divider),
                            _hoisted_29,
                            _hoisted_30
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class"]),
                        (_ctx.vN$.password.$error)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.vN$.password.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_Password, {
                          id: "confPassword",
                          modelValue: _ctx.vN$.confirm_Password.$model,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vN$.confirm_Password.$model) = $event)),
                          class: _normalizeClass({
                                                'p-error':
                                                _ctx.vN$.confirm_Password.$error && _ctx.submit_reg_nuev,
                                            }),
                          toggleMask: ""
                        }, null, 8, ["modelValue", "class"]),
                        (_ctx.vN$.confirm_Password.$error && _ctx.submit_reg_nuev)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_ctx.vN$.confirm_Password.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_InputMask, {
                        modelValue: _ctx.state_reg_nuev.telefono,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state_reg_nuev.telefono) = $event)),
                        mask: "(+99) 999-9999999",
                        placeholder: "(+99) 999-9999999"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_InputText, {
                        id: "Inst",
                        modelValue: _ctx.state_reg_nuev.institution,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state_reg_nuev.institution) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_ctx.vN$.institution.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_40, _toDisplayString(_ctx.vN$.institution.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createTextVNode("  "),
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.state_reg_nuev.idSubsector,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state_reg_nuev.idSubsector) = $event)),
                        options: _ctx.catsubsector,
                        optionLabel: "nombre_sector",
                        optionValue: "id_sector",
                        placeholder: "Seleccione el Sector",
                        class: "w-full"
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.vN$.idSubsector.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_ctx.vN$.idSubsector.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createTextVNode("  "),
                      _createVNode(_component_InputText, {
                        id: "sector",
                        modelValue: _ctx.state_reg_nuev.otroSubsector,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state_reg_nuev.otroSubsector) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_ctx.vN$.otroSubsector.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.vN$.otroSubsector.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, this.state_reg_nuev.idSubsector == 4]
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_CaptchaCanvas, {
                          ref: "captchaRef",
                          captchaValid: _ctx.captchaValida
                        }, null, 8, ["captchaValid"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createVNode(_component_Button, {
                            label: "Cancelar",
                            class: "p-button p-button-lg p-button-secondary w-12 justify-content-center border-round p-3 text-white",
                            onClick: navigate,
                            role: "link"
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_Button, {
                        label: "Registrar",
                        class: "p-button-lg w-12 border-round p-3 text-white",
                        onClick: _ctx.submit_nuevo_user
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.registroNuevo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, " Hemos enviado un correo electrónico a \"" + _toDisplayString(this.state_reg_nuev.email) + "\" para verificar su cuenta. ", 1),
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createVNode(_component_Button, {
                            class: "p-button w-8rem border-round p-3 text-white",
                            onClick: navigate,
                            label: " Inicio",
                            role: "link"
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}